var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',_vm._b({attrs:{"indeterminate":"","size":_vm.size,"width":_vm.width,"color":_vm.color}},'v-progress-circular',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }